export const tradeChartTutorialSteps = [
    {
        title: ' Welcome',
        intro: 'Welcome to the walkthough of the StellarFX chart.',
    },
    {
        element: '#trade_fav_button',
        title: 'Favorite',
        intro: 'Clicking the favorite icon will add this pair to your favorite list. This list is stored in your local browser as well as the sidebar, for your convenience. ',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '#trade_token_pair',
        title: 'Toggle Denomination',
        intro: 'Clicking either the token pair images or token pair symbol will switch the denomination of the pair. ',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '#trade_chart_full_screen_button',
        title: 'Full Screen Chart',
        intro: 'You can go into full screen mode of the chart by clicking here. While in full screen mode, you can exit by pressing the same button you used to initiate full screen or simply hit escape on your keyboard.',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '#trade_chart_save_image',
        title: 'Save Chart Image',
        intro: 'You have the option to save the chart image as a jPeg.',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '#trade_charts_time_frame',
        title: 'Time Frame',
        intro: 'Something about the time frame',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '#trade_charts_volume_tvl',
        title: 'Volume, Tvl, and Fee Rate',
        intro: 'Something about the volume, tvl, and fee rate',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
    {
        element: '#trade_charts_curve_depth',
        title: 'Curve and Depth',
        intro: 'Something about the curve and depth',
        position: 'bottom',
        tooltipClass: 'myTooltipClass',
        highlightClass: 'myHighlightClass',
    },
];
